exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".o-container{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0 1.75rem}@media (min-width:60em){.o-container{padding:0 5.25rem 0 2.45rem}}", ""]);

// exports
